

import StockReturnToSupplier  from '@/components/backOffice/StockReturnToSupplier.vue'

import movementList           from '@/components/backOffice/MovementList.vue'
import productSearch          from '@/components/common/SearchProduct.vue'
import ready                  from '@/components/backOffice/ready/Main.vue'
import category               from '@/components/category/Category.vue'

import supplierAllDocuments   from '@/components/backOffice/SupplierAllDocuments.vue'

const menuId = 'bo1'

const routes = [
        
    
    {
        path        : '/product-search',
        name        : 'product_search',
        component   : productSearch,
        meta        : { name : 'Ricerca Prodotti', visible : true ,icon : 'fas fa-binoculars',menu:menuId,color:'#990000'},
        //props       : (route) => ({ route: route.query.q })  
    },
    
    {
        path        : '/ready',
        name        : 'ready',
        component   : ready,
        meta        : { name : 'Carico diretto (DDT/Fattura)', visible : true ,icon : 'fas fa-boxes',menu:menuId,color:'navy'},
         
    },

    {
        path        : '/supplierPickingList',
        name        : 'supplierStockReturn',
        component   :  StockReturnToSupplier,
        meta        : { name : 'Reso a fornitore - packing List', visible : true ,icon : 'fas fa-th-list',menu:menuId,color:'#FF6600'},
         
    },
    {
        path        : '/movementList',
        name        : 'movementList',
        component   : movementList,
        meta        : { name : 'Movimenti Fornitore', visible : true ,icon : 'fas fa-th',menu:menuId,color:'#339900'},
         
    },
    {
        path        : '/category',
        name        : 'category',
        component   : category,
        meta        : { name : 'Classificazione categoria', visible : true ,icon : 'fas fa-swatchbook',menu:menuId,color:'brown'},
         
    },

    {
        path        : '/supplierAllDocuments', 
        component   : supplierAllDocuments,
        name        : 'supplierAllDocuments',
        meta        : { name : 'Documenti di acquisto fornitori', visible : true ,icon : 'far fa-list-alt',menu:menuId,color:'blue'},   
    },
  

    
]
export default routes